import { createType } from './create-type.js';
import { LiteralTypeDescription } from './literal-type-description.js';

export const literal = <T extends string | number | boolean>(constant: T) =>
  createType<LiteralTypeDescription<T>>({
    description: { type: 'literal', constant },
  });
